import React from "react";

/**
 * DS Button — Figma "대시보드 리뉴얼" button-primary / -secondary / -tertiary.
 *
 * variant: "primary" (BG/Accent), "secondary" (white + border), "tertiary" (Gray/90),
 *          "danger" (Red/5 bg + System/Error text — 삭제 등)
 * size: "xs" (radius 4, 12/18 caption), "sm" (py=8 → h=38), "md" (py=10 → h=42, default), "lg" (py=12 → h=46 모달 액션)
 *
 * @param {object} props
 * @param {"primary"|"secondary"|"tertiary"|"danger"} [props.variant="secondary"]
 * @param {"xs"|"sm"|"md"|"lg"} [props.size="md"]
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.loading] - true 면 disabled + children 대신 스피너(.primary-loader, currentColor)
 * @param {React.ReactNode} [props.icon] - 좌측 아이콘 (optional)
 * @param {React.ReactNode} props.children
 * @param {(e: React.MouseEvent) => void} [props.onClick]
 * @param {string} [props.className]
 * @param {React.CSSProperties} [props.style]
 * @param {"button"|"submit"|"reset"} [props.type="button"]
 */
const DSButton = ({
  variant = "secondary",
  size = "md",
  disabled = false,
  loading = false,
  icon,
  children,
  onClick,
  className = "",
  style,
  type = "button",
}) => {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      onClick={onClick}
      style={style}
      className={`ds-button ds-button--${size} ds-button--${variant}${
        loading ? " ds-button--loading" : ""
      } ${className}`}
    >
      {loading ? (
        <span className="primary-loader ds-button__loader" aria-hidden />
      ) : (
        <>
          {icon}
          {children}
        </>
      )}
    </button>
  );
};

export default React.memo(DSButton);
